module.exports = __webpack_public_path__ + "static/media/css.9701cf1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/css.png
// module id = 51
// module chunks = 0